import ItemsSliderPresenter from "../components/items-slider/presenter/items-slider.js";

const listElement = document.querySelector(`.category-links_quiz`);

if (listElement) {
  const itemsSliderComponent = new ItemsSliderPresenter(listElement);
  itemsSliderComponent.init();
}
